<template>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2 pl-0">
            <div class="vx-card mt-2 p-6 height-card">
                <div class="component">
                    <span class="text-title-ages">
                    {{ $t("title.ages") }}
                    <!-- <div v-if="!showWorkChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> -->
                    </span>
                </div>
                <div class="component">
                    <span class="text-sub">
                        {{ $t('shareOfVoice.agesOfRation') }}
                    </span>
                </div>
            </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 p-0">
            <div class="vx-card mt-2 p-6 height-card">
                <div class="component">
                    <span class="text-title-ages">
                    {{ $t("title.ages") }}
                    <!-- <div v-if="!showWorkChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div> -->
                    </span>
                </div>
                <div class="component">
                    <span class="text-sub">
                        {{ $t('shareOfVoice.agesCorrelation') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.height-card {
  height: 396px;
}
.text-title-ages {
    font-size: 18px;
    font-weight: bold;
    color: #5E5873;
}
.text-sub {
    font-size: 14px;
    color: #B9B9C3;
}
</style>